/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteResponseRequest = {
  responseId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteResponseRequest$inboundSchema: z.ZodType<
  DeleteResponseRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  response_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "response_id": "responseId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteResponseRequest$Outbound = {
  response_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteResponseRequest$outboundSchema: z.ZodType<
  DeleteResponseRequest$Outbound,
  z.ZodTypeDef,
  DeleteResponseRequest
> = z.object({
  responseId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    responseId: "response_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteResponseRequestToJSON(
  deleteResponseRequest: DeleteResponseRequest,
): string {
  return JSON.stringify(
    DeleteResponseRequest$outboundSchema.parse(deleteResponseRequest),
  );
}
export function deleteResponseRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteResponseRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteResponseRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteResponseRequest' from JSON`,
  );
}
